import { useEffect, useState } from 'react';
import { Link, useDisclosure } from '@chakra-ui/react';
import { Modal, ModalOverlay, ModalBody, ModalFooter, ModalContent, ModalCloseButton, Button, Flex, Text, AspectRatio, Image } from '@chakra-ui/react'
import { FcGoogle } from "react-icons/fc";
import { useTranslation } from 'react-i18next';
import AppBar from './AppBar';
import TabBar from './TabBar';
import GoogleReviewLogo from '../../assets/GoogleReviewLogo.png'



import { connect } from 'react-redux';

const mapStateToProps = (state) => {
    return {
        lang: state.language,
        categories: state.categories,
        restaurantName: state.restaurantName,
        restaurantInfo: state.restaurantInfo
    }
}

function gaussianRandom(mean=0, stdev=1) {
    const u = 1 - Math.random(); // Converting [0,1) to (0,1]
    const v = Math.random();
    const z = Math.sqrt( -2.0 * Math.log( u ) ) * Math.cos( 2.0 * Math.PI * v );
    // Transform to the desired mean and standard deviation:
    return z * stdev + mean;
}

const Overlay = (props) => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [modalTimeout, setModalTimeout] = useState(null)
    const { t } = useTranslation()

    useEffect(() => {
        if (!!props.restaurantInfo?.googleReviewsLink) {
            const sampledTimeout = gaussianRandom(120, 80) * 1000 

            console.log("Showing modal in " + sampledTimeout + " ms")

            setModalTimeout(
                setTimeout(
                    () => {
                        onOpen()
                    }, sampledTimeout
                )
            )

            return () => {
                    clearTimeout(modalTimeout)
                }
            }
        },  [props.restaurantInfo?.googleReviewsLink]
    )

    return ( 
        <>
            <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalCloseButton />
                <ModalBody>

                <Flex direction="column" alignItems="center">
                    <Text fontFamily="Monotype Corsiva" fontSize="2xl" textAlign="center">
                        { t("review_us_modal_support_business") }
                    </Text>

                    <Text fontFamily="Roboto" fontWeight="bold" fontSize="3xl" textAlign="center" lineHeight="1.8rem" mt={3}>
                        { t("review_us_modal_headline") }
                    </Text>

                    <Text fontSize="small" color="BlackAlpha.700" textAlign="center" lineHeight="1rem" mt={3}>
                        { t("review_us_modal_subheadline") }
                    </Text>

                    <Button 
                        leftIcon={<FcGoogle />}
                        backgroundColor="black" 
                        color="white" 
                        variant='unstyled' 
                        borderRadius="20" 
                        pl={6} pr={6} 
                        mt={6}
                    >
                        <Link href={props.restaurantInfo?.googleReviewsLink} target="_blank">
                            { t("review_us_modal_button_text") }
                        </Link>
                    </Button>

                    <Text fontSize="small" color="BlackAlpha.700" textAlign="center" lineHeight="1rem" mt={6}>
                        { t("review_us_modal_greeting_text") }
                    </Text>

                    <AspectRatio ratio={16.0/9.0} width="45%">
                        <Image src={GoogleReviewLogo} />
                    </AspectRatio>
                </Flex>
                
                </ModalBody>
                <ModalFooter>
                <Button colorScheme='blue' mr={3} onClick={onClose}>
                    Close
                </Button>
                </ModalFooter>
            </ModalContent>
            </Modal>
            { props.restaurantName && <AppBar/> }
            { props.categories && <TabBar/> }
        </>
   ) 
}

export default connect(mapStateToProps)(Overlay);

/*
    
                <iframe
                    is="x-frame-bypass"
                    title="Google Review"
                    src="https://www.google.com"
                    width="100%"
                    height="500"
                    frameBorder="0"
                    ></iframe>
*/